import { Dayjs } from 'dayjs'
import { User } from '../user/user-typed'
import { Transaction } from '../transaction/transaction-typed'

export enum EnumGiveawayStatus {
  PENDING = 'pending',
  PROCESSING = 'processing',
  SUCCESS = 'success',
  FAIL = 'fail',
}

export enum EnumGiveawayUnit {
  gram = 'gram',
  baht = 'baht',
}

export type ICreateGiveawayBody = {
  tmnId: string
  prefix: string
  amount: number
  unit: any
  campaign: string
  otp?: string
  otpId?: string
  tmnTransactionId?: string
}

export type IPageMeta = {
  currentPage: number
  itemCount: number
  itemsPerPage: number
  totalItems: number
  totalPages: number
}

interface IImportGiveawaysFileSummary {
  importGiveawayFileId: string
  total: number
  countPending: number
  countProcessing: number
  countSuccess: number
  countFail: number
}

export type IGiveaway = {
  id: string
  createdAt: string
  updatedAt: string
  deletedAt: any
  userId: string
  amount: number
  status: string
  prefix: string
  campaignName: string
  unit: string
  creatorId: string
  transactionId: string
  user: User
  transaction?: Transaction
  errorMessage?: string
  tmnTransactionId: string
}

export interface IGiveawayFile {
  id: string
  createdAt: Date
  updatedAt: Date
  deletedAt: null
  fileName: string
  creatorId: string
  s3Response: IS3Response
  status: string
  summary: IImportGiveawaysFileSummary
}

export interface IS3Response {
  Key: string
  key: string
  ETag: string
  Bucket: string
  Location: string
  ServerSideEncryption: string
}

export type IGiveawayFileList = {
  items: IGiveawayFile[]
  meta: IPageMeta
}

export type IGiveawayList = {
  items: IGiveaway[]
  meta: IPageMeta
}

export type IExportGiveawayReportParams = {
  prefix?: string
  startDate: Dayjs
  endDate: Dayjs
  status?: EnumGiveawayStatus
  unit?: EnumGiveawayUnit
}

export type IGiveAwayFileBody = {
  file: File | null
  otpData: {
    otp?: string
    otpId?: string
  }
}
